

































import { Vue, Component, Prop } from 'vue-property-decorator';
import {PHONE_PREFIXES} from "@/constants/phone";
import {normalizeFormatB} from "@/services/Phones";

@Component({
  name: 'PhoneInput',
})
export default class PhoneInput extends Vue {
  @Prop({ default: ''})
  private value!: string;


  @Prop({ default: '+34'})
  private defaultPrefix?: string;

  @Prop({ default: () => (e: any) => null })
  private removeErrorFunc?: (e: any) => void;

  @Prop({ default: () => (e: any) => null })
  private error?: (e: any) => void;

  private readonly phonePrefixes = PHONE_PREFIXES;
  private phoneNumberPrefix: string = '+34';
  private phoneNumberNumber: string = '';
  private forceFocus: boolean = false;

  private created() {
    this.$emit('input', this.phoneNumberPrefix + this.phoneNumberNumber); // emit the default values
  }

  private updateValueTel(value: string) {
    this.phoneNumberNumber = normalizeFormatB(value);
    this.emitValueToParent();
  }

  private updateValuePrefix(value: string) {
    this.phoneNumberPrefix = value;
    this.emitValueToParent();
  }

  private emitValueToParent() {
    this.$emit('input', this.phoneNumberPrefix + this.phoneNumberNumber);
  }

  private focusInInput(e: any) {
    this.forceFocus = true;
    if (this.removeErrorFunc) {
       this.removeErrorFunc(e);
    }
  }

  private blurInInput() {
    this.forceFocus = false;
  }
}
